import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import makeStyles from '@material-ui/core/styles/makeStyles';
import { Collapse } from '@material-ui/core';
import ExpandLessRoundedIcon from '@material-ui/icons/ExpandLessRounded';
import ExpandMoreRoundedIcon from '@material-ui/icons/ExpandMoreRounded';

const useStyles = makeStyles(theme => ({
  panel: {
    background: theme.palette.white,
    boxShadow: `0px 6px 12px ${theme.palette.black}14`,
    border: `1px solid ${theme.palette.grey.medium}`,
    opacity: 1,
    outline: 'none'
  },
  title: {
    textAlign: 'left',
    font: '20px',
    letterSpacing: '0px',
    textTransform: 'uppercase',
    padding: '18px',
    outline: 'none'
  },
  expandedTitle: {
    background: `${theme.palette.primary.main} 0% 0% no-repeat padding-box`,
    opacity: 1,
    color: theme.palette.white
  },
  icon: {
    float: 'right'
  }
}));

const ExpansionPanel = ({ title, children, id, expanded, handleChange, ...rest }) => {
  const classes = useStyles();

  const isExpanded = expanded === id;

  return (
    <div className={classes.panel}>
      <div
        onClick={handleChange}
        role="button"
        id={id}
        tabIndex="0"
        className={isExpanded ? classNames(classes.title, classes.expandedTitle) : classes.title}
        {...rest}
      >
        {title}
        {isExpanded ? (
          <ExpandLessRoundedIcon className={classes.icon} />
        ) : (
          <ExpandMoreRoundedIcon className={classes.icon} />
        )}
      </div>
      <Collapse in={isExpanded}>{children}</Collapse>
    </div>
  );
};

ExpansionPanel.propTypes = {
  title: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  expanded: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired
};

export default ExpansionPanel;
